/// value and values are not required depending on operatorType, like "is not null"
export interface IAdvancedFilter {
    key: string;
    operatorType: Operator;
    values?: string[] | number[];
    value?: number | boolean;
}

export enum Operator {
    NumberIn = 'NumberIn',
    NumberNotIn = 'NumberNotIn',
    NumberLessThan = 'NumberLessThan',
    NumberGreaterThan = 'NumberGreaterThan',
    NumberLessThanOrEquals = 'NumberLessThanOrEquals',
    NumberGreaterThanOrEquals = 'NumberGreaterThanOrEquals',
    NumberInRange = 'NumberInRange',
    NumberNotInRange = 'NumberNotInRange',
    BoolEquals = 'BoolEquals',
    StringContains = 'StringContains',
    StringNotContains = 'StringNotContains',
    StringBeginsWith = 'StringBeginsWith',
    StringNotBeginsWith = 'StringNotBeginsWith',
    StringEndsWith = 'StringEndsWith',
    StringNotEndsWith = 'StringNotEndsWith',
    StringIn = 'StringIn',
    StringNotIn = 'StringNotIn',
    IsNullOrUndefined = 'IsNullOrUndefined',
    IsNotNull = 'IsNotNull'
}
